import React, { useContext, useEffect, useState } from 'react'
import { Icon } from 'semantic-ui-react'
import { useSelector } from 'react-redux'
import Swal from 'sweetalert2'
import { Tree, TreeNode } from 'react-organizational-chart'
import { CustomerViewContext } from '../customer-info-view/customerView'
import { getHierarchy, getRegions } from '../../../../services/customer'
import ViewSitesModal from './viewSitesModal'
import EditHierarchyModal from './editHierarchyModal'
import DeleteHierarchyModal from './deleteHierarchyModal'
import './viewSitesModal.css'

const style = {
  padding: '5px',
  width: 'auto',
  borderRadius: '8px',
  display: 'inline-block',
  border: '1px solid #000',
  backgroundColor: '#4B6587',
  cursor: 'pointer',
  color: '#FFF',
}
const TreeHierarchy = () => {
  const { customerSettings } = useContext(CustomerViewContext)
  const customer = localStorage.getItem('customerName')
  const { customerId, customerName } = useSelector((store) => ({
    customerId: store.facility.customerId,
    customerName: store.facility.customerName,
  }))
  console.log('customerId', customerName)
  console.log('customerId', customerId)
  const product = localStorage.getItem('product')
  const [zones, setZones] = useState([])
  const [regions, setRegions] = useState({})
  const [sites, setSites] = useState([])
  const [open, setOpen] = useState(false)
  const [openEdit, setOpenEdit] = useState(false)
  const [openDelete, setOpenDelete] = useState(false)
  const [selectedLevel, setSelectedLevel] = useState({})

  // useEffect(() => {
  //   ;(async () => {
  //     Swal.showLoading()
  //     const queryParams = {
  //       customerId:
  //         product === 'cold' ? customerId : customerSettings.tbCustomerId,
  //       type: product === 'cold' ? 'country' : 'zone',
  //       product,
  //     }
  //     const res = await getHierarchy(queryParams)
  //     Swal.close()
  //     setZones(res.data)
  //   })()
  // }, [])

  useEffect(() => {
    ;(async () => {
      Swal.showLoading()
      const queryParams = {
        customerId:
          product === 'cold' ? customerId : customerSettings.tbCustomerId,
        type: product === 'cold' ? 'country' : 'zone',
        product,
      }
      if (customerId || (customerSettings && customerSettings.tbCustomerId)) {
        const res = await getHierarchy(queryParams)
        Swal.close()
        setZones(res.data)
      }
    })()
  }, [customerId])

  const getOpenState = (openState) => setOpen(openState)

  const renderRegions = (zoneId) => {
    if (regions[zoneId]) {
      return regions[zoneId].map((region) => (
        <TreeNode
          label={
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions
            <div
              style={{
                ...style,
                backgroundColor: '#f2f3f5',
                color: '#000',
                whiteSpace: 'nowrap',
                borderColor: '#FFF',
              }}
              onClick={() => getSites(region)}
              onKeyDown={handleKey}
            >
              <b>{region.label || region.name} </b>
              {product !== 'cold' && (
                <>
                  <Icon
                    name="edit"
                    onClick={(e) => handleEditLevel(e, region)}
                  />
                  <Icon
                    name="trash alternate"
                    onClick={(e) =>
                      handleDeleteLevel(e, { ...region, levelType: 'level2' })
                    }
                  />
                </>
              )}
              <br />
              {region.count && <b>({region.count})</b>}
            </div>
          }
        ></TreeNode>
      ))
    }

    return null
  }

  const getEditModalState = (editState) => setOpenEdit(editState)
  const getDeleteModalState = (deleteState) => setOpenDelete(deleteState)

  const handleEditLevel = (e, levelData) => {
    e.stopPropagation()
    setOpenEdit(true)
    setSelectedLevel(levelData)
    console.log('level data: ', levelData)
  }

  const handleDeleteLevel = (e, levelData) => {
    e.stopPropagation()
    setOpenDelete(true)
    setSelectedLevel(levelData)
    console.log('level data: ', levelData)
  }

  const refreshTree = async () => {
    Swal.showLoading()
    const queryParams = {
      customerId:
        product === 'cold' ? customerId : customerSettings.tbCustomerId,
      type: product === 'cold' ? 'country' : 'zone',
      product,
    }
    const res = await getHierarchy(queryParams)
    Swal.close()
    setZones(res.data)
  }

  const renderZones = (treeZones) =>
    treeZones.map((zone) => (
      <TreeNode
        label={
          // eslint-disable-next-line jsx-a11y/no-static-element-interactions
          <div
            onClick={() => handleClick(zone)}
            onKeyDown={handleKey}
            style={{
              ...style,
              backgroundColor: '#7f90a9',
              color: '#FFF',
              whiteSpace: 'nowrap',
              borderColor: '#FFF',
            }}
          >
            <b>
              {zone.label || zone.name}{' '}
              {regions[zone.id] ? (
                <Icon name="minus circle" />
              ) : (
                <Icon name="plus circle" />
              )}
            </b>
            {product !== 'cold' && (
              <>
                <Icon name="edit" onClick={(e) => handleEditLevel(e, zone)} />
                <Icon
                  name="trash alternate"
                  onClick={(e) =>
                    handleDeleteLevel(e, { ...zone, levelType: 'level1' })
                  }
                />
              </>
            )}
          </div>
        }
      >
        {renderRegions(zone.id)}
      </TreeNode>
    ))

  const handleClick = async (zone) => {
    const zoneId = zone.id
    const queryParams = {
      product,
      customerId:
        product === 'cold' ? customerId : customerSettings.tbCustomerId,
    }
    if (regions[zone.id]) {
      setRegions((prevState) => {
        const newState = { ...prevState }
        delete newState[zone.id]
        return newState
      })
      return
    }
    Swal.showLoading()
    const res = await getRegions(queryParams, zoneId)
    Swal.close()
    setRegions((prevState) => ({ ...prevState, [zoneId]: res.data }))
  }

  const getSites = async (region) => {
    const regionId = region.id
    const queryParams = {
      product,
      customerId:
        product === 'cold' ? customerId : customerSettings.tbCustomerId,
      levelType: product === 'cold' ? 'Facility' : 'site',
    }
    Swal.showLoading()
    const res = await getRegions(queryParams, regionId)
    Swal.close()
    console.log('facility data', res)
    setSites(res.data)
    setOpen(true)
  }

  const handleKey = (e) => e.preventDefault()
  return (
    <div
      style={{
        minHeight: '350px',
        backgroundColor: '#303D54',
        margin: '20px 0',
        border: '1px solid',
      }}
    >
      <h3
        style={{
          backgroundColor: '#4B6587',
          padding: '10px',
          color: '#FFF',
          textAlign: 'center',
        }}
      >
        Customer Hierarchy View
      </h3>
      <div style={{ overflow: 'auto', height: '350px' }}>
        <Tree
          label={
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions
            <div
              onClick={() => refreshTree()}
              onKeyDown={handleKey}
              style={{
                ...style,
                backgroundColor: '#fff',
                color: '#000',
                borderColor: '#FFF',
              }}
            >
              {product === 'cold' ? (
                <b>{customerName || customer}</b>
              ) : (
                <b>{customerSettings.title}</b>
              )}
            </div>
          }
        >
          {renderZones(zones)}
        </Tree>
      </div>

      <ViewSitesModal
        sites={sites}
        open={open}
        getOpenState={getOpenState}
        customerId={
          product === 'cold' ? customerId : customerSettings.tbCustomerId
        }
      />
      {product !== 'cold' && (
        <>
          <EditHierarchyModal
            level={selectedLevel}
            openEdit={openEdit}
            getEditModalState={getEditModalState}
          />
          <DeleteHierarchyModal
            level={selectedLevel}
            openDelete={openDelete}
            getDeleteModalState={getDeleteModalState}
          />
        </>
      )}
    </div>
  )
}

export default TreeHierarchy
